/* eslint-disable indent */
import React from 'react';
import PropTypes from 'prop-types';

import { Container, Content, Nub } from './tooltip.css';

function Tooltip(props) {
	const {
		text,
		position = 'top',
		size,
		delay = false,
		children,
		background = 'blue-base',
		showArrow = true,
		fontSize,
		disabled = false,
		style = {}
	} = props;

	return disabled
		? children
		: (
			<Container position={position} style={style}>
			{showArrow && <Nub position={position} delay={delay}/>}
			<Content
				position={position}
				size={size}
				fontSize={fontSize}
				delay={delay}
				background={background}
			>
				{text}
			</Content>

			{children}

		</Container>
	);
}

Tooltip.propTypes = {
	text: PropTypes.string.isRequired,
	position: PropTypes.string,
	size: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	fontSize: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	delay: PropTypes.bool,
	background: PropTypes.string,
	showArrow: PropTypes.bool,
	disabled: PropTypes.bool,
	style: PropTypes.object
};

export default Tooltip;
